import routes from './routes'
import Page from './page'
import linked from './linked'
import store from 'store'
import Bus from 'util/bus'

let curr = null

function setPage() {
  let o = curr || {}
  store.setPage({
    url: o.url,
    prev: o.prev != null,
    next: o.next != null
  })
}

function navigateTo(url) {
  if (curr) curr.page.switchOut()
  curr = linked.add(new Page(url))
  curr.page.switchIn()
  history.pushState({url}, '', url)
  setPage()
}

function redirectTo(url) {
  if (curr) curr.page.switchOut(false, true)
  curr = linked.replace(new Page(url))
  history.replaceState({url}, '', url)
  setPage()
}

function switchTab(url) {
  if (curr && curr.page.url == url) return
  if (curr) curr.page.switchOut(false, true)
  linked.remove()
  curr = linked.reset(new Page(url))
  curr.page.switchIn()
  history.replaceState({url}, '', url)
  setPage()
}

function navigateBack(url = '/') {
  if (!curr || !curr.prev) {
    return redirectTo(url)
  }
  curr.page.switchOut(true)
  curr = linked.back()
  if (curr) {
    curr.page.switchIn(true)
  }
  setPage()
}

function navigateForward() {
  if (!curr || !curr.next) throw new Error('can not perform navigateForward')
  curr.page.switchOut()
  curr = linked.curr = curr.next
  curr.page.switchIn()
  setPage()
}

window.addEventListener('popstate', e => {
  curr = curr || {}
  let {url} = e.state
  let {prev, next} = curr
  if (prev && url == prev.url) {
    navigateBack()
  } else if (next && url == next.url) {
    navigateForward()
  } else {
    if (curr.page) curr.page.remove()
    curr = linked.reset(new Page(url))
    curr.page.switchIn()
    setPage()
  }
})

export function bind() {
  Bus.on('navigateTo', url => {
    navigateTo(url)
  })
  Bus.on('redirectTo', url => {
    redirectTo(url)
  })
  Bus.on('switchTab', url => {
    switchTab(url)
  })
  Bus.on('navigateBack', url => {
    if (store.hasBack) {
      history.back()
    } else {
      redirectTo(url)
    }
  })
}

export function checkCurrentPage() {
  let url = `${location.pathname}${location.search}`
  if (!curr || curr.page.url != url) {
    if (routes[location.pathname]) {
      redirectTo(url)
    } else {
      redirectTo('/')
    }
  }
}
